var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Multiselect', {
    staticClass: "app-single-select",
    class: {
      'app-single-select--has-error': _vm.hasError
    },
    attrs: {
      "options": _vm.options,
      "label": _vm.label,
      "track-by": "value",
      "placeholder": _vm.placeholder,
      "selectLabel": "請選擇",
      "selectedLabel": "（已勾選）",
      "deselectLabel": "取消勾選",
      "disabled": _vm.disabled,
      "id": _vm.id,
      "allowEmpty": _vm.clearable
    },
    on: {
      "input": _vm.handleSelect
    },
    model: {
      value: _vm.selected,
      callback: function callback($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_c('div', [_vm._v("查無資料")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }